/* eslint-disable react/prop-types */
import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function FormInput({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
  disabled = false,
  required = false,
  multiline = false,
  rows = 1,
  startIcon = null,
  endIcon = null,
  helperText = "",
  error = false,
}) {
  return (
    <ArgonBox mb={2}>
      {label && (
        <ArgonTypography variant="caption" fontWeight="bold" mb={0.5} display="block">
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </ArgonTypography>
      )}
      <TextField
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        multiline={multiline}
        rows={rows}
        variant="outlined"
        size="medium"
        error={error}
        helperText={helperText}
        InputProps={{
          startAdornment: startIcon ? (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ) : null,
          endAdornment: endIcon ? <InputAdornment position="end">{endIcon}</InputAdornment> : null,
        }}
      />
    </ArgonBox>
  );
}

export default FormInput;
